import React from "react";
import { UncerTainIcon } from "@edricphan2022/uikit";
import styled, { keyframes } from "styled-components";

const uncertainSliderShadow = keyframes`
 0% {
    filter: drop-shadow(6px -5px 0px rgba(247, 218, 87, 0.499999));
  }
  25% {
    filter: drop-shadow(-6px -5px 0px rgba(247, 218, 87, 0.499999));
  }
  50% {
    filter: drop-shadow(-8px 7px 0px rgba(247, 218, 87, 0.499999));
  }
  75% {
    filter: drop-shadow(-6px 5px 0px rgba(247, 218, 87, 0.499999));
  }
  100% {
    filter: drop-shadow(6px -5px 0px rgba(247, 218, 87, 0.499999));
  }
`;

const uncertainSlider = keyframes`
 0% {
    top: 0%;
    left: 0%;
  }
  25% {
    top: 0%;
    left: 10%;
  }
  50% {
    top: 10%;
    left: 10%;
  }
  75% {
    top: 10%;
    left: 0%;
  }
  100% {
    top: 0%;
    left: 0%;
  }
`;

const Warrper = styled.div`
  .uncertainGroup {
    width: 113px;
    height: 113px;
    position: relative;
  }
  .uncertain {
    position: absolute;
    top: 12px;
    left: 5px;
  }
  .uncertainSvg {
    filter: drop-shadow(6px -5px 0px rgba(247, 218, 87, 1));
    overflow: inherit;
  }
  .uncertainSvg path {
    filter: drop-shadow(8px 0px 0px rgba(247, 218, 87, 0.299999));
  }
  .uncertainSliderShadow {
    animation-name: ${uncertainSliderShadow};
    animation-duration: 7s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
  .uncertainSlider {
    animation-name: ${uncertainSlider};
    animation-duration: 5s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
`;

interface UncerTainIconsProps {
  width: string;
}

const UncerTainIcons: React.FC<UncerTainIconsProps> = ({ width }) => {
  return (
    <Warrper>
      <div className="uncertainGroup ">
        <div className="uncertain uncertainSlider">
          <UncerTainIcon className="uncertainSvg uncertainSliderShadow " width={width} />
        </div>
      </div>
    </Warrper>
  );
};

export default React.memo(UncerTainIcons);
